import Vue from 'vue'
import App from './App.vue'  
import router from "./router"  
import ElementUI from 'element-ui'; 
import 'element-ui/lib/theme-chalk/index.css'
import echarts from 'echarts'
import components from '@/utils/components.js'  ;
import directives from '@/utils/directives.js';
import ajaxapi from "@/utils/api.js" ;
import geojson from "@/utils/geoChina.js" ;
// import axios from 'axios';
import axios from './utils/axios';
import vueSeamlessScroll from 'vue-seamless-scroll';
import store from '@/store/store.js'; 
import common from '@/components/inc/common.vue';
import BaiduMap from 'vue-baidu-map' ; 
import VueDraggableResizable from 'vue-draggable-resizable'
import VueTour from 'vue-tour';

// import Driver from '@/utils/driver.js'
// import 'driver.js/dist/driver.min.css' 
// Vue.prototype.$driver = new Driver()


Vue.prototype.common = common;
Vue.prototype.$api = ajaxapi;
Vue.prototype.$geoJson = geojson;
Vue.prototype.$store=store; 
import scroll from 'vue-seamless-scroll' 
import screenfull from 'screenfull'; 
import AmapVue from '@amap/amap-vue'
 
Vue.use(ElementUI) 
Vue.use(scroll)
Vue.use(VueTour) //新手指引弹框
require('vue-tour/dist/vue-tour.css')

Vue.use(directives) //全局注册指令 
Vue.use(components) //全局注册组件  
Vue.use(vueSeamlessScroll);//无缝滚动插件
Vue.component('vue-draggable-resizable', VueDraggableResizable) 
Vue.use(BaiduMap,{ak: 'VBHDaDcjTbRt3CGDc4XUHCoxYn8owNh8'}); //百度地图秘钥 
AmapVue.config.key = 'db3d68e47dbd589e106d4524d8c26a1d'  //高德地图
Vue.use(AmapVue)
// import VueQuillEditor from 'vue-quill-editor' 

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
 
Vue.config.productionTip = false
Vue.prototype.$echarts = echarts;
const domianOnline ='https://www.zhaoshangdanao.com/#/user-login';
const domianLocal = 'http://192.168.1.82:8083/#/user-login';
const domian = process.env.NODE_ENV === 'production' ? domianOnline : domianLocal;
Vue.prototype.getuseriformation = function () { 
	let dataddd = localStorage.getItem('userData') ? localStorage.getItem('userData') : sessionStorage.getItem('userData');
	let temData ={};
	if (typeof dataddd  == 'object') {
		 temData = dataddd;
	} else {
		 temData = JSON.parse(dataddd);
	} 
	// console.log(temData,'------');
	if(!temData){
		temData = {
			currentCity: {
				text: ""
			},
			username:'',
			remainDays:'',
			endDate:'',
			operatList: {
				mkczsm: false
			},
			zsdn_version:2,
			groupType:0,
			token: null
		};
	}
	return temData;
}
 

	//公用传值axios
	Vue.prototype.getAxiosData=function(url,token,funs){
		var _this=this;
		this.$axios.get(url, {
			headers: {
				AuthToken: token
			}
		}).then(function(res) { 
			// console.log('企业列表', res.data);
			if (res.data.success) {
			 funs(res.data);
			} 
		}).catch(function(error) {}); 
	},

//验证登录失败成功 可删除搁置
Vue.prototype.tokenfailed=function(msg,url){
	console.log('tokenfailed',msg,url); 
  return;
	if(msg){
		if(msg.indexOf('oken')>-1 || msg == "logout"){
			console.log('msg token',msg.indexOf('oken'))
			localStorage.clear('userData');
			sessionStorage.clear('userData'); 
			// this.$router.push({path: "/login"});
			window.location.href = ajaxapi.getLogoutUrl();
		}
	} 
}  
//登出
Vue.prototype.logout=function(){
	const temisChannel = JSON.parse( localStorage.getItem('userData') );
	localStorage.removeItem('userData');
	sessionStorage.removeItem('userData');
	this.common.islogin=false;
	this.common.userdata={}; 
	const isLoginUrl = temisChannel.isChannel?'/#/xsb-login': ajaxapi.getLogoutUrl();
	console.log('isChannelUser',temisChannel,isLoginUrl);
	window.location.href = isLoginUrl;
} 
//列表页和详情页的添加关系计算器的企业列表  type为1添加熟悉企业 type为2添加想联系的企业 是否多选code isMultiple
Vue.prototype.toggleRelationEnterprise=function(list,type,isMultiple){
	var _this=this,ajaxurl="",ajaxdata={},msgtext="",relationid=0,stockCodeContent='';
	if(!isMultiple){
		relationid=list.enterpriseRelationId;
		stockCodeContent=list.stockCode;
	}else{
		//如果多选，遍历list提取企业code，用逗号隔开
		stockCodeContent=list.map(item => item.stockCode).join(',');
		console.log('stockCodeContent',stockCodeContent);
	}
	
	// type=list.enterpriseRelationType > 0 ?list.enterpriseRelationType:type;
	var typetext=type == 1 ? '熟悉的企业' : '想联系的企业';
	if(relationid > 0){
		//删除
		ajaxurl=this.$api.cyl.enterpriseRelation.deleteEnterprise();
		ajaxdata={id:relationid};
		msgtext='已移除'+typetext;
	}else{
		//新增
		ajaxurl=this.$api.cyl.enterpriseRelation.addEnterprise();
		ajaxdata={stockCode:stockCodeContent,type:type};
		msgtext='已加入'+typetext;
	} 
	$.ajax({
		type:"POST",
		url:ajaxurl,
		data:ajaxdata,
		headers:{AuthToken:this.userdata.token },
		success:function(res){ 
			// console.log('toggleRelationEnterprise',res);
			var msgtype=res.success?'success':'error';
			console.log(res)
			if(res.success){ 
				if(relationid == 0){
					list.enterpriseRelationId=res.data.id; 
					list.enterpriseRelationType=res.data.type; 
				}else{
					list.enterpriseRelationId=0; list.enterpriseRelationType=0;
				}   
			}else{ 
				msgtext=res.msg;
			} 
			_this.$message({
				type: msgtype,
				message: msgtext,
			});
		} 
	}) 
	
	
}

//列表收藏和详情页收藏 type == acoc 代表是传list.id 不传为list.stockCode
Vue.prototype.listToggleCollect=function(list,type){
	console.log('listToggleCollect',list);
	 var _this=this,cid=list.collectId;
	 var ajaxurl="",ajaxdata={},msgtext="",msgtype="";
		var cids=type == 'acoc'?list.id:list.stockCode;
	 if(cid == 0){
	  ajaxurl=this.$api.cyl.collect.add();
	 	ajaxdata={type:list.collectType,id:cids}
	 	}else{
	 		ajaxurl=this.$api.cyl.collect.remove();
	 		ajaxdata={collectId:list.collectId};
	 	} 
	 	$.ajax({
	 		type:"POST",
	 		url:ajaxurl,
	 		data:ajaxdata,
	 		headers:{AuthToken:this.userdata.token },
	 		success:function(res){ 
	 			// console.log('1123',list.collectId,res,list.stockCode);
	 			if(res.success){
	 				if(cid == 0){
	 					list.collectId=res.data.collectId;
							msgtext="已加入目标企业";
	 				}else{
	 					list.collectId=0;
							msgtext="已移除目标企业";
	 				}  
						msgtype="success";
	 			}else{
						msgtype="error";
						msgtext=res.msg;
					} 
					_this.$message({
						type: msgtype,
						message: msgtext,
					});
	 		} 
	 	})   
} 

Vue.prototype.tagrouter=function(path,pagetype,type,id,name,pagename){ 
	let routeUrl = this.$router.resolve({
		path: path,query: {type:pagetype,key:type,id:id,keyword:name,pagename:pagename}
});
	window.open(routeUrl.href, '_blank');  
}
Vue.prototype.getSetCity=function(udata){
	var setCityArry={type:"",text:"",id:0,userAbbr:"",calcuId:0,calCuText:"",mapname:"",noZhixia:true}; 
	if(udata.county > 0){
		setCityArry.type="county";
		setCityArry.text=udata.countyText;
		setCityArry.id=udata.county;
		setCityArry.calCuText=udata.cityText;
		setCityArry.calcuId=udata.city;
		setCityArry.mapname=udata.city+'00';
		// setCityArry={type:"county",text:udata.countyText,id:udata.county,};
		// console.log(1)
	}else if(udata.city > 0){
		setCityArry.type="city";
		setCityArry.text=udata.cityText;
		setCityArry.id=udata.city;
		setCityArry.calCuText=udata.cityText;
		setCityArry.calcuId=udata.city;
		setCityArry.mapname=udata.city+'00';
		// setCityArry={type:"city",text:udata.cityText,id:udata.city,};
			// console.log(2)
	}else if(udata.province > 0){
		setCityArry.type="province";
		setCityArry.text=udata.provinceText;
		setCityArry.id=udata.province;
		setCityArry.calCuText=udata.provinceText;
		setCityArry.calcuId=udata.province; 
		// 将省份名称转换为拼音
        // const provincePinyin = pinyin(udata.provinceText, { style: pinyin.STYLE_NORMAL }).join('');
        // setCityArry.mapname = provincePinyin;
		if(udata.province == 31){
			setCityArry.mapname="shanghai";
			setCityArry.noZhixia=false;
		}else if(udata.province == 50){
			setCityArry.mapname="chongqing";
			setCityArry.noZhixia=false;
		} else if(udata.province == 11){
			setCityArry.mapname="beijing";
			setCityArry.noZhixia=false;
		}else if(udata.province == 12){
			setCityArry.mapname="tianjin"; 
			setCityArry.noZhixia=false;
		} 
	}
	
	if(udata.userAbbr!=""){
		setCityArry.userAbbr=udata.userAbbr;
	}else{
		setCityArry.userAbbr=setCityArry.text;
	}
	return setCityArry;
}
Vue.prototype.downloadUrl=function(url){  //下载报告 
				// this.iframeurl=ajaxapi.getDownloadUrl(this.userdata.token,this.enterpriseid,this.userdata.city,this.companyinfor.title);
			 
				var iframe = document.getElementById("exportIframe");
				 
				iframe.setAttribute("src", url);
				setTimeout(()=>{
				 // this.iframestus=true; 
				},60000)
			},
Vue.prototype.emptyStr=function(str){  //监测当前数据是否为空或者为0 如果是空或者0 则显示-
	 var strs=(!str || str.length<1 || str == 0) ? '-':str;
		return strs;
},
Vue.prototype.getCalcuCity=function(data){  //获取用户当地产业图谱和作战线索的省市区名字和id 
 var calCuData={text:"",id:"",type:""};
	if(data.currentCity.type == 'province'){
		calCuData=data.currentCity;
	}else{
		calCuData.text=data.cityText;
		calCuData.id=data.city;
		calCuData.type='city';
	}
	return calCuData;
},

Vue.prototype.getCurentTime=function(path,pagetype,type,id,name,pagename){ 
	var date = new Date();
	//以下代码依次是获取当前时间的年月日时分秒
	var year = date.getFullYear();
	var month = date.getMonth() + 1;
	var strDate = date.getDate();
	var minute = date.getMinutes();
	var hour = date.getHours();
	var second = date.getSeconds();
	//固定时间格式
	if (month >= 1 && month <= 9) {
	month = "0" + month;
	}
	if (strDate >= 0 && strDate <= 9) {
	strDate = "0" + strDate;
	}
	if (hour >= 0 && hour <= 9) {
			hour = "0" + hour;
	}
	if (minute >= 0 && minute <= 9) {
			minute = "0" + minute;
	}
	if (second >= 0 && second <= 9) {
			second = "0" + second;
	}
	var currentdate = "_" + year + month + strDate + hour + minute + second;
	return currentdate;
}
Vue.prototype.routerlinkid=function(path,id,type,code,pagename){ 
	if(!path || path == ''){return;}
	let dataddd=sessionStorage.getItem('userData') ? sessionStorage.getItem('userData'):localStorage.getItem('userData') ;
	var userdatacom={};
	if(typeof(dataddd) == 'object'){
	userdatacom = dataddd;
	}else{
	userdatacom = JSON.parse(dataddd);
	}    
	if(userdatacom.isFree|| (!userdatacom.token && path == '/enterprises')){
		path='/enterprises-free';

	}
	var pathque={id:id};
	if(type){
		pathque={id:id,type:type?type:'',pagename:pagename?pagename:''};
	} 
	let token = btoa(userdatacom.token);
	let queryString =  btoa(path+'?' + Object.keys(pathque).map(key => `${key}=${pathque[key]}`).join('&'));
	
	window.open(domian+'?token='+token+'&refer='+queryString, '_blank');  
}
Vue.prototype.routerlinkarry=function(path,arry){   
	let routeUrl = this.$router.resolve({
			path: path,query: arry
	});
	window.open(routeUrl.href, '_blank');  
}
Vue.prototype.routerblank=function(path){  
	let userData = this.getuseriformation();
	if(!path || path == ''){return;}
	// let routeUrl = this.$router.resolve({
	// 		path: path, 
	// });
	let token = btoa(userData.token);
	let queryString = btoa(path);
	window.open(domian+'?token='+token+'&refer='+queryString, '_blank');  
}
Vue.prototype.routerself=function(path){  
	let routeUrl = this.$router.resolve({
			path: path, 
	});
	window.open(routeUrl.href, '_self');  
}
Vue.prototype.handlerLinkLocal=function(path){  
	let routeUrl = this.$router.resolve({
			path: path, 
	});
	window.open(routeUrl.href, '_blank');  
}
Vue.prototype.handlerLink=function(url){  
	window.location.href = url;	
}
//数组字符串拼接
Vue.prototype.datajoin=function(name, data) { 
	var ddd='';
	if(data.length>0){
		ddd='&'+name+'='+data.join('%2C');
	}
	return ddd;
} 

	//省份去重  
Vue.prototype.unique=function(arr) {
	const res = new Map();
	return arr.filter((arr) => !res.has(arr.name) && res.set(arr.name, 1));
},
Vue.prototype.taglistfun=function(ac,bc,style){
	let arrys=[];
	if(ac == ""){
		return arrys;
	}
	let dd=ac.split(',');
	let de=bc.split(',');  
	for(var i=0;i<dd.length;i++){
		arrys.push({name:dd[i],id:de[i]}); 
	}  
	if(style == 'notionsort'){
		let arry1=arrys.filter((list=>{
			return list.id.indexOf('A')===0;
		}))
		let arry2=arrys.filter((list=>{
			return list.id.indexOf('A')!=0;
		}))
		
		arrys=arry1.concat(arry2);
	} 
	return arrys; 
}
Vue.prototype.citynameremove=function(namef){
	console.log('剔除数据',namef)
		namef=namef.replace('省',"");
		namef=namef.replace('市',"");
		namef=namef.replace('维吾尔自治区',"");
		namef=namef.replace('壮族自治区',"");
		namef=namef.replace('回族自治区',"");
		namef=namef.replace('自治区',"");  
		namef=namef.replace('区',"");  
		return namef;
	},
	//验证是否为空参数
	Vue.prototype.splicing=function(name, value, isFirst) {
			var url1 = '';
			let symbol = isFirst ? "?" : "&";
			if (value != '' && value != null && value != 0 && value != 'all') {
				url1 = symbol + name + '=' + value;
			}
			return url1;
		},
	Vue.prototype.screen = function(){
		    if (!screenfull.enabled) {
		      // 如果不允许进入全屏，发出不允许提示
		      this.$message({
		        message: '不支持全屏',
		        type: 'warning',
		      });
		      return;
		    }
		    screenfull.toggle(document.getElementById('full-screen')); 
	},
	 
// const routerPush = Router.prototype.push;
// Router.prototype.push = function push(location) {
// return routerPush.call(this, location).catch(error=> error)
// }
axios.defaults.checkAuth=true;
// axios.interceptors.request.use(config=>{ 
// 		var userData=this.getuseriformation();
// 		// console.log('main',userData)
// 		if(config.checkAuth){
// 		if(userData==""|| !userData.token){
// 		localStorage.clear('userData');
// 		sessionStoreage.clear('userData');
// 		this.$router.push({path:"/login"});
// 		return;
// 		}
// 		if(userData.token){
// 			config.headers.Authorization=userData.token;
// 			console.log(config);
// 		}
// 		}
// 		return config;
// });



// axios.interceptors.request.use(
//   config => {
//     var token = this.getuseriformation().token;
// 				console.log(token)
//     if (token) {  // 判断是否存在token，如果存在的话，则每个http header都加上token
//       token =sessionStorage.getItem('token')+':';
//       config.headers.Authorization = `Basic ${new Buffer(token).toString('base64')}`;
//     }
//     return config;
//   },
//   err => {
//     return Promise.reject(err);
//   }); 
Vue.prototype.$axios = axios;
Vue.prototype.bus = new Vue;

 // 显示loading
// this.bus.$emit('loading', true);
 
// 关闭loading
// this.bus.$emit('loading', false);

new Vue({
	store,
	router, 
  render: h => h(App),
}).$mount('#app')
